import * as React from 'react';
import { useDispatch } from 'react-redux';
import { cleanUpCurrentProject } from 'spw-redux/modules/projects/actions';
import {
  DialogBox,
  DialogCustom,
  GradientBackgroundContainer,
  Title,
} from './components/login/styles';

const NotFound = () => {
  const dispatch = useDispatch();
  const isMounted = React.useRef(false);

  React.useEffect(() => {
    return () => {
      if (isMounted.current) dispatch(cleanUpCurrentProject());
      else isMounted.current = true;
    };
  }, [dispatch]);

  return (
    <GradientBackgroundContainer>
      <DialogBox>
        <DialogCustom>
          <Title>Space Plan Wizard</Title>
          <br />
          <Title>404</Title>
          <p>We could not find the page you requested</p>
        </DialogCustom>
      </DialogBox>
    </GradientBackgroundContainer>
  );
};

export default NotFound;
